<template>
  <div class="container">
    <div class="site-form-layer construct-form-layer max-1032">
      <div class="site-form-title construct-form-title">1. Тип заявления:</div>
      <div class="site-form-row construct-form-row">
        <div class="site-form-col construct-form-col">
          <dropdown v-if="typeDocument" :values="typeDocument" v-model="form.STATEMENT" :name="`STATEMENT`" label="Заявление"/>
        </div>
      </div>
      <div class="site-form-row construct-form-row">
        <div class="site-form-col construct-form-col">
          <dropdown v-if="typeApplicant" :values="typeApplicant" v-model="form.APPLICANT" name="APPLICANT" label="Тип заявителя"/>
        </div>
      </div>
      <div class="site-form-row construct-form-row">
        <div class="site-form-col construct-form-col">
          <dropdown v-if="typeAgreement" :values="typeAgreement" v-model="form.AGREEMENT" name="AGREEMENT" label="Вид договора"/>
        </div>
      </div>
    </div>
    <div class="site-form-layer construct-form-layer max-1032">
      <div class="site-form-title construct-form-title">2. Информация о заявителе:</div>
      <div class="site-form-row construct-form-row">
        <div class="site-form-col construct-form-col">
          <form-input label="Полное наименование" v-model="form.APPLICANT_FULL_NAME" name="APPLICANT_FULL_NAME"/>
        </div>
      </div>
      <div class="site-form-row construct-form-row">
        <div class="site-form-col construct-form-col">
          <form-input label="Сокращенное наименование" v-model="form.APPLICANT_SHORT_NAME" name="APPLICANT_SHORT_NAME"/>
        </div>
      </div>
      <div class="site-form-row construct-form-row">
        <div class="site-form-col construct-form-col">
          <form-input label="Номер записи в ЕГРЮЛ" v-model="form.NUM_EGRUL" name="NUM_EGRUL"/>
        </div>
        <div class="site-form-col construct-form-col">
          <form-input label="Дата внесения в ЕГРЮЛ" v-model="form.DATE_EGRUL" name="DATE_EGRUL"/>
        </div>
      </div>
    </div>
    <div class="site-form-layer construct-form-layer max-1032">
      <div class="site-form-title construct-form-title">3. Сведения о государственной регистрации</div>
      <div class="site-form-row construct-form-row">
        <div class="site-form-col construct-form-col x4">
          <form-input label="ИНН" v-model="form.INN" name="INN"/>
        </div>
        <div class="site-form-col construct-form-col x4">
          <form-input label="ОГРН" v-model="form.OGRN" name="OGRN"/>
        </div>
        <div class="site-form-col construct-form-col x4">
          <form-input label="КПП" v-model="form.KPP" name="KPP"/>
        </div>
      </div>
    </div>
    <div class="site-form-layer construct-form-layer max-1032">
      <div class="site-form-title construct-form-title m-0">4. Контактные данные</div>
      <div class="construct-form-group-container">
        <div class="construct-form-group">
          <div class="construct-form-explant">Данные для связи</div>
          <div class="site-form-row construct-form-row">
            <div class="site-form-col construct-form-col">
              <phone label="Моб. Телефон" v-model="form.PHONE_1" name="PHONE_1"/>
            </div>
          </div>
          <div class="site-form-row construct-form-row">
            <div class="site-form-col construct-form-col">
              <form-input label="E-Mail" v-model="form.EMAIL_1" name="EMAIL_1"/>
            </div>
          </div>
        </div>
        <div class="construct-form-group">
          <div class="construct-form-explant">Дополнительные данные для связи</div>
          <div class="site-form-row construct-form-row">
            <div class="site-form-col construct-form-col">
              <phone label="Моб. Телефон" v-model="form.PHONE_2" name="PHONE_2"/>
            </div>
          </div>
          <div class="site-form-row construct-form-row">
            <div class="site-form-col construct-form-col">
              <form-input label="E-Mail" v-model="form.EMAIL_2" name="EMAIL_2"/>
            </div>
          </div>
        </div>
      </div>
      <!--        <div class="construct-form-explant">Платежные документы (счет-фактура, акт приема-передачи, счет на оплату) прошу направлять:</div>-->
      <div class="site-form-row construct-form-row">
        <div class="site-form-col construct-form-col x6">
          <dropdown :values="typeEdo" v-model="form.TYPE_EDO" name="TYPE_EDO" label="Используемый ЭДО"/>
        </div>
        <!--          <div class="site-form-col construct-form-col">-->
        <!--            <checkbox-->
        <!--                name="TYPE_EDO_HAND"-->
        <!--                label="Нарочно"-->
        <!--            />-->
        <!--          </div>-->
      </div>
    </div>

    <div class="site-form-layer construct-form-layer max-1032" v-if="form.STATEMENT !=='change_agree'">
      <div class="site-form-title construct-form-title">5. Банковские реквизиты</div>
      <div v-for="index in countBanks" style="margin-bottom:20px;">
        <div class="site-form-row construct-form-row">
          <div class="site-form-col construct-form-col">
            <form-input label="Наименование банка" :name="`BANK_INFO[${index-1}][BANK_NAME]`" v-model="form.BANK_INFO[index-1].BANK_NAME"/>
          </div>
        </div>
        <div class="site-form-row construct-form-row x4">
          <div class="site-form-col construct-form-col">
            <form-input label="Расчетный счет №" v-model="form.BANK_INFO[index-1].BANK_ACCOUNT" :name="`BANK_INFO[${index-1}][BANK_ACCOUNT]`"/>
          </div>
          <div class="site-form-col construct-form-col">
            <form-input label="Бик" v-model="form.BANK_INFO[index-1].BIK" :name="`BANK_INFO[${index-1}][BIK]`"/>
          </div>
          <div class="site-form-col construct-form-col">
            <form-input label="Кор. счет №" v-model="form.BANK_INFO[index-1].BANK_CORRESPONDENT" :name="`BANK_INFO[${index-1}][BANK_CORRESPONDENT]`"/>
          </div>
        </div>
      </div>

      <div class="site-form-row construct-form-row">
        <div class="site-form-col construct-form-col">
          <!-- construct-form-lg-margin-->
          <button class="construct-form-add " type="button" @click.prevent="addBank"><span>Добавить счет</span></button>
        </div>
      </div>


      <div class="site-form-row construct-form-row">
        <div class="site-form-col construct-form-col">
          <div class="construct-form-md-margin">
            <checkbox label="Лицо, имеющее право подписи от имени заявителя" name="CONFIDANT" v-model="form.CONFIDANT"/>
          </div>
        </div>
      </div>
    </div>

    <div class="site-form-layer construct-form-layer max-1032" v-if="form.STATEMENT !=='change_agree'">
      <div class="site-form-title construct-form-title">6. Юридический адрес (Адрес регистрации)</div>
      <div class="site-form-row construct-form-row">
        <div class="site-form-col construct-form-col">
          <form-input label="Страна" v-model="form.REG_COUNTRY" name="REG_COUNTRY"/>
        </div>
        <div class="site-form-col construct-form-col">
          <form-input label="Регион" v-model="form.REG_REGION" name="REG_REGION"/>
        </div>
      </div>
      <div class="site-form-row construct-form-row">
        <div class="site-form-col construct-form-col">
          <form-input label="Населенный пункт" v-model="form.REG_CITY" name="REG_CITY"/>
        </div>
        <div class="site-form-col construct-form-col">
          <form-input label="Улица" v-model="form.REG_STREET" name="REG_STREET"/>
        </div>
      </div>
      <div class="site-form-row construct-form-row">
        <div class="site-form-col construct-form-col x4">
          <form-input label="Дом" v-model="form.REG_HOME" name="REG_HOME"/>
        </div>
        <div class="site-form-col construct-form-col x4">
          <form-input label="Квартира" v-model="form.REG_APARTMENT" name="REG_APARTMENT"/>
        </div>
        <div class="site-form-col construct-form-col x4">
          <form-input label="Индекс" v-model="form.REG_INDEX" name="REG_INDEX"/>
        </div>
      </div>
      <div class="site-form-row construct-form-row">
        <div class="site-form-col construct-form-col">
          <div class="construct-form-lg-margin" style="margin-top:25px;">
            <checkbox
                v-model="form.reg_ident_post"
                label="Почтовый адрес совпадает с юридическим (адресом регистрации)"
            />
          </div>
        </div>
      </div>
    </div>

    <div class="site-form-layer construct-form-layer max-1032" v-if="form.STATEMENT !=='change_agree'">
      <div class="site-form-title construct-form-title">7. Почтовый адрес</div>
      <div class="site-form-row construct-form-row">
        <div class="site-form-col construct-form-col">
          <form-input label="Страна" v-model="form.POST_COUNTRY" name="POST_COUNTRY" :is-disabled="form.reg_ident_post"/>
        </div>
        <div class="site-form-col construct-form-col">
          <form-input label="Регион" v-model="form.POST_REGION" name="POST_REGION" :is-disabled="form.reg_ident_post"/>
        </div>
      </div>
      <div class="site-form-row construct-form-row">
        <div class="site-form-col construct-form-col">
          <form-input label="Населенный пункт" v-model="form.POST_CITY" name="POST_CITY" :is-disabled="form.reg_ident_post"/>
        </div>
        <div class="site-form-col construct-form-col">
          <form-input label="Улица" v-model="form.POST_STREET" name="POST_STREET" :is-disabled="form.reg_ident_post"/>
        </div>
      </div>
      <div class="site-form-row construct-form-row">
        <div class="site-form-col construct-form-col x4">
          <form-input label="Дом" v-model="form.POST_HOME" name="POST_HOME" :is-disabled="form.reg_ident_post"/>
        </div>
        <div class="site-form-col construct-form-col x4">
          <form-input label="Квартира" v-model="form.POST_APARTMENT" name="POST_APARTMENT" :is-disabled="form.reg_ident_post"/>
        </div>
        <div class="site-form-col construct-form-col x4">
          <form-input label="Индекс" v-model="form.POST_INDEX" name="POST_INDEX" :is-disabled="form.reg_ident_post"/>
        </div>
      </div>
    </div>
    <div class="site-form-title construct-form-title" v-if="form.STATEMENT !=='change_agree'">8. Прошу заключить договор в отношении объекта(ов)</div>

  </div>


  <div class="site-form-layer construct-form-layer" v-if="form.STATEMENT !=='change_agree'">
    <div v-for="index in countObjects">
      <div class="max-1032">

        <div class="site-form-row construct-form-row">
          <div class="site-form-col construct-form-col">
            <form-input label="Наименование объекта" v-model="form.OBJECTS[index-1].OBJECT_NAME" :name="`OBJECTS[${index-1}][OBJECT_NAME]`"/>
          </div>
          <div class="site-form-col construct-form-col">
            <form-input label="Адрес объекта" v-model="form.OBJECTS[index-1].OBJECT_ADDRESS" :name="`OBJECTS[${index-1}][OBJECT_ADDRESS]`"/>
          </div>
        </div>

        <div class="site-form-row construct-form-row">
          <div class="site-form-col construct-form-col">
            <form-input label="Ценовая категория" v-model="form.OBJECTS[index-1].OBJECT_PRICE" :name="`OBJECTS[${index-1}][OBJECT_PRICE]`"/>
          </div>
          <div class="site-form-col construct-form-col">
            <form-input label="Максимальная мощность, кВт" v-model="form.OBJECTS[index-1].OBJECT_MAX_POWER" :name="`OBJECTS[${index-1}][OBJECT_MAX_POWER]`"/>
          </div>
        </div>

        <div class="construct-form-explant">Номер и дата действующего договора энергоснабжения (купли-продажи (поставки) электрической энергии (мощности)) (при наличии)</div>
        <div class="site-form-row construct-form-row">
          <div class="site-form-col construct-form-col x6">
            <form-input label="Договор энергоснабжения" v-model="form.OBJECTS[index-1].OBJECT_AGREEMENT" :name="`OBJECTS[${index-1}][OBJECT_AGREEMENT]`"/>
          </div>
        </div>

        <div class="construct-form-explant">Показания приборов учета на дату перехода права собственности на объект, подписанные предыдущим и новым собственником (при наличии)</div>
        <div class="site-form-row construct-form-row">
          <div class="site-form-col construct-form-col x6">
            <form-input label="Показания приборов" v-model="form.OBJECTS[index-1].OBJECT_METER" :name="`OBJECTS[${index-1}][OBJECT_METER]`"/>
          </div>
        </div>

        <div class="construct-form-explant">Срок, на который необходимо заключить договор (при отсутствии необходимости заключения договора на определенный срок указать «бессрочно» )</div>
        <div class="site-form-row construct-form-row">
          <div class="site-form-col construct-form-col x6">
            <form-input label="Срок договора" v-model="form.OBJECTS[index-1].OBJECT_DURATION" :name="`OBJECTS[${index-1}][OBJECT_DURATION]`"/>
          </div>
        </div>

      </div>

      <div class="container">
        <div class="site-form-layer construct-form-layer">
          <!--        <div class="site-form-title construct-form-title m-0">8.1. Планируемый объем потребления электроэнергии</div>-->
          <div class="construct-form-group-container">
            <div class="construct-form-group full">
              <div class="construct-form-explant">Объем указывать в кВт*ч</div>
              <div>
                <div class="site-form-row construct-form-row">
                  <div class="site-form-col construct-form-col x12">
                    <form-input label="Январь" v-model="form.OBJECTS[index-1].JAN" :name="`OBJECTS[${index-1}][JAN]`"/>
                  </div>
                  <div class="site-form-col construct-form-col x12">
                    <form-input label="Февраль" v-model="form.OBJECTS[index-1].FEB" :name="`OBJECTS[${index-1}][FEB]`"/>
                  </div>
                  <div class="site-form-col construct-form-col x12">
                    <form-input label="Март" v-model="form.OBJECTS[index-1].MARCH" :name="`OBJECTS[${index-1}][MARCH]`"/>
                  </div>
                  <div class="site-form-col construct-form-col x12">
                    <form-input label="Апрель" v-model="form.OBJECTS[index-1].APRIL" :name="`OBJECTS[${index-1}][APRIL]`"/>
                  </div>
                  <div class="site-form-col construct-form-col x12">
                    <form-input label="Май" v-model="form.OBJECTS[index-1].MAY" :name="`OBJECTS[${index-1}][MAY]`"/>
                  </div>
                  <div class="site-form-col construct-form-col x12">
                    <form-input label="Июнь" v-model="form.OBJECTS[index-1].JUNE" :name="`OBJECTS[${index-1}][JUNE]`"/>
                  </div>
                </div>
                <div class="site-form-row construct-form-row">
                  <div class="site-form-col construct-form-col x12">
                    <form-input label="Июль" v-model="form.OBJECTS[index-1].JULY" :name="`OBJECTS[${index-1}][JULY]`"/>
                  </div>
                  <div class="site-form-col construct-form-col x12">
                    <form-input label="Август" v-model="form.OBJECTS[index-1].AUG" :name="`OBJECTS[${index-1}][AUG]`"/>
                  </div>
                  <div class="site-form-col construct-form-col x12">
                    <form-input label="Сентябрь" v-model="form.OBJECTS[index-1].SEPT" :name="`OBJECTS[${index-1}][SEPT]`"/>
                  </div>
                  <div class="site-form-col construct-form-col x12">
                    <form-input label="Октябрь" v-model="form.OBJECTS[index-1].OKT" :name="`OBJECTS[${index-1}][OKT]`"/>
                  </div>
                  <div class="site-form-col construct-form-col x12">
                    <form-input label="Ноябрь" v-model="form.OBJECTS[index-1].NOV" :name="`OBJECTS[${index-1}][NOV]`"/>
                  </div>
                  <div class="site-form-col construct-form-col x12">
                    <form-input label="Декабрь" v-model="form.OBJECTS[index-1].DEC" :name="`OBJECTS[${index-1}][DEC]`"/>
                  </div>
                </div>
                <div class="site-form-row construct-form-row">
                  <div class="site-form-col construct-form-col x12">
                    <form-input label="Всего" v-model="form.OBJECTS[index-1].TOTAL" :name="`OBJECTS[${index-1}][TOTAL]`"/>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>

    </div>

    <div class="site-form-row construct-form-row">
      <div class="site-form-col construct-form-col">
        <!--construct-form-lg-margin-->
        <button class="construct-form-add " @click.prevent="addObject"><span>Добавить объект</span></button>
      </div>
    </div>
  </div>

  <div class="container">
    <div class="site-form-layer construct-form-layer max-1032">
      <div class="site-form-title construct-form-title">9. Информация о договоре</div>
      <div class="site-form-row construct-form-row">
        <div class="site-form-col construct-form-col">
          <dropdown v-if="receiveAgreement" :values="receiveAgreement" v-model="form.RECEIVE_AGREEMENT" name="RECEIVE_AGREEMENT" label="Способ получения договора"/>
        </div>
      </div>
      <div class="site-form-row construct-form-row" v-if="form.STATEMENT==='change_agree'">
        <div class="site-form-col construct-form-col">
          <form-input label="Номер договора" v-model="form.NUMBER_AGREEMENT" :name="`NUMBER_AGREEMENT`"/>
        </div>
      </div>
    </div>
    <div class="site-form-layer construct-form-layer max-1032" id="docs">
      <div class="site-form-title construct-form-title">Перечень документов необходимых для заключения договора энергоснабжения и купли-продажи</div>
      <div class="construct-form-upload-container">
        <div class="construct-form-upload">
          <div class="construct-form-upload-item">
            <div class="construct-form-upload-title">1. Заявление на заключение договора с указанием</div>
            <div class="construct-form-upload-point">ФИО руководителя (полностью), юридического адреса, телефонов, адреса электронной почты, банковских реквизитов, адреса нахождения объекта (объектов) электроснабжения Заявителя, планируемого объема потребления электрической энергии (количества электрической энергии с разбивкой по месяцам), величины максимальной мощности энергопринимающих устройств с ее распределением по точкам поставки.</div>
            <file v-model="form.FILE_STATEMENT" name="FILE_STATEMENT"/>
          </div>
        </div>
        <div class="construct-form-upload">
          <div class="construct-form-upload-item">
            <div class="construct-form-upload-title">2. Проект договора энергоснабжения</div>
            <div class="construct-form-upload-point">(купли-продажи (поставки) электрической энергии (мощности)), подписанный заявителем, или проект договора энергоснабжения (купли-продажи(поставки) электрической энергии (мощности)) подписанный заявителем, с протоколом разногласий к проекту договора, форма которого размещена (опубликована) гарантирующим поставщиком на сайте www.bges.ru (предоставляется по желанию заявителя).</div>
            <file
                v-model="form.FILE_DRAFT_AGREEMENT"
                name="FILE_DRAFT_AGREEMENT"
                :accept="getExtension('FILE_DRAFT_AGREEMENT')"
            />
          </div>
        </div>
        <div class="construct-form-upload">
          <div class="construct-form-upload-item">
            <div class="construct-form-upload-title">3. Правоустанавливающие и иные документы:</div>
            <div class="construct-form-upload-point">Свидетельство о государственной регистрации юридического лица или в качестве индивидуального предпринимателя;</div>
            <file
                v-model="form.FILE_MAIN_DOCS"
                name="FILE_MAIN_DOCS"
                :accept="getExtension('FILE_MAIN_DOCS')"
            />
          </div>
          <div class="construct-form-upload-item">
            <div class="construct-form-upload-point">Свидетельство о постановке на учет в налоговом органе*;</div>
            <file
                v-model="form.FILE_REG_TAX"
                name="FILE_REG_TAX"
                :accept="getExtension('FILE_REG_TAX')"
            />
          </div>
          <div class="construct-form-upload-item">
            <div class="construct-form-upload-point">Документ, подтверждающий ОКВЭД;</div>
            <file
                v-model="form.FILE_DOC_OKVED"
                name="FILE_DOC_OKVED"
                :accept="getExtension('FILE_DOC_OKVED')"
            />
          </div>
          <div class="construct-form-upload-item">
            <div class="construct-form-upload-point">Документы, подтверждающие полномочия лица, подписавшего заявление от имени Заявителя - выписка из протокола (решения, приказа) о назначении на должность руководителя или доверенность на подписание договора, если договор подписывает не руководитель;</div>
            <file
                v-model="form.FILE_DOC_PERMISSION"
                name="FILE_DOC_PERMISSION"
                :accept="getExtension('FILE_DOC_PERMISSION')"
            />
          </div>
          <div class="construct-form-upload-item">
            <div class="construct-form-upload-point">Копия паспорта гражданина Российской Федерации, если заявителем выступает индивидуальный предприниматель или гражданин;</div>
            <file
                v-model="form.FILE_PASSPORT_COPY"
                name="FILE_PASSPORT_COPY"
                :accept="getExtension('FILE_PASSPORT_COPY')"
            />
          </div>
          <div class="construct-form-upload-item">
            <div class="construct-form-upload-point">Устав, Положение – для филиалов.</div>
            <file
                v-model="form.FILE_DOC_RULES"
                name="FILE_DOC_RULES"
                :accept="getExtension('FILE_DOC_RULES')"
            />
          </div>
        </div>
        <div class="construct-form-upload">
          <div class="construct-form-upload-item">
            <div class="construct-form-upload-title">4. Документы, подтверждающие право собственности</div>
            <div class="construct-form-upload-point">(хозяйственного ведения, оперативного управления, аренды и иные законные права владения и (или) пользования, предусмотренные законодательством Российской Федерации) на энергопринимающие устройства, либо документы, подтверждающие право владения и (или) пользования земельным участком, о снабжении которых электрической энергией указано в заявлении о заключении договора.*</div>
            <file
                v-model="form.FILE_DOC_OWNER"
                name="FILE_DOC_OWNER"
                :accept="getExtension('FILE_DOC_OWNER')"
            />
          </div>
          <div class="construct-form-upload-item">
            <div class="construct-form-upload-point">Для кооперативов гаражей – справку о количестве гаражей и информацию о собственниках или иных владельцев, либо иных объектов, расположенных в границах территории кооператива.</div>
            <file
                v-model="form.FILE_DOC_COUNT_GARAGE"
                name="FILE_DOC_COUNT_GARAGE"
                :accept="getExtension('FILE_DOC_COUNT_GARAGE')"
            />
          </div>
        </div>
        <div class="construct-form-upload">
          <div class="construct-form-upload-item">
            <div class="construct-form-upload-title">5. Документы, подтверждающие технологическое присоединение (в том числе и опосредованно) в установленном порядке к объектам электросетевого хозяйства сетевой организации энергопринимающих устройств, о снабжении электрической энергией которых указано в заявлении о заключении договора, иные документы:</div>
            <div class="construct-form-upload-point">акт о технологическом присоединении, составленный и подписанный Абонентом и сетевой организацией, к чьим сетям (энергетическим установкам) присоединены энергопринимающие устройства Абонента и (или) акт разграничения балансовой принадлежности электросетей (при смене владельца предоставляется при наличии).</div>
            <file
                v-model="form.FILE_DOC_TECH_ACCEPT"
                name="FILE_DOC_TECH_ACCEPT"
                :accept="getExtension('FILE_DOC_TECH_ACCEPT')"
            />
          </div>
          <div class="construct-form-upload-item">
            <div class="construct-form-upload-point">акт допуска прибора учета в эксплуатацию (при смене владельца предоставляется при наличии)</div>
            <file
                v-model="form.FILE_ACT_ACCEPT"
                name="FILE_ACT_ACCEPT"
                :accept="getExtension('FILE_ACT_ACCEPT')"
            />
          </div>
          <div class="construct-form-upload-item">
            <div class="construct-form-upload-point">акт согласования технологической и (или) аварийной брони, согласованный ООО «Барнаульская сетевая компания» (предоставляется при его наличии).</div>
            <file
                v-model="form.FILE_TECH_BOOKING_BSK"
                name="FILE_TECH_BOOKING_BSK"
                :accept="getExtension('FILE_TECH_BOOKING_BSK')"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Dropdown from "../../form/dropdown.vue";
import FormInput from "../../form/input.vue";
import Checkbox from "../../form/checkbox.vue";
import File from "../../form/file.vue";
import Phone from "../../form/phone.vue";

export default {
  name: "jur-template",
  components: {Phone, File, Checkbox, FormInput, Dropdown},
  data() {
    return {
      countBanks: 1,
      countObjects: 1,
    };
  },
  watch: {
    'form.reg_ident_post': function (val) {

      if (val === true) {

        this.form.POST_COUNTRY = this.form.REG_COUNTRY;
        this.form.POST_REGION = this.form.REG_REGION;
        this.form.POST_CITY = this.form.REG_CITY;
        this.form.POST_STREET = this.form.REG_STREET;
        this.form.POST_APARTMENT = this.form.REG_HOME;
        this.form.POST_HOME = this.form.REG_APARTMENT;
        this.form.POST_INDEX = this.form.REG_INDEX;

      } else if (val === false) {

        this.form.POST_COUNTRY = null;
        this.form.POST_REGION = null;
        this.form.POST_CITY = null;
        this.form.POST_STREET = null;
        this.form.POST_APARTMENT = null;
        this.form.POST_HOME = null;
        this.form.POST_INDEX = null;

      }

    },
    'form.REG_COUNTRY': function (val) {
      if (this.form.reg_ident_post === true) {
        this.form.POST_COUNTRY = val;
      }
    },
    'form.REG_REGION': function (val) {
      if (this.form.reg_ident_post === true) {
        this.form.POST_REGION = val;
      }
    },
    'form.REG_CITY': function (val) {
      if (this.form.reg_ident_post === true) {
        this.form.POST_CITY = val;
      }
    },
    'form.REG_STREET': function (val) {
      if (this.form.reg_ident_post === true) {
        this.form.POST_STREET = val;
      }
    },
    'form.REG_HOME': function (val) {
      if (this.form.reg_ident_post === true) {
        this.form.POST_HOME = val;
      }
    },
    'form.REG_APARTMENT': function (val) {
      if (this.form.reg_ident_post === true) {
        this.form.POST_APARTMENT = val;
      }
    },
    'form.REG_INDEX': function (val) {
      if (this.form.reg_ident_post === true) {
        this.form.POST_INDEX = val;
      }
    },
  },
  props: {
    form: {
      type: Object,
      default: null
    },
    formKey: {
      type: String,
      default: null
    },
    typeAgreement: {
      type: Object,
      default: null
    },
    receiveAgreement: {
      type: Object,
      default: null
    },
    typeDocument: {
      type: Object,
      default: null
    },
    typeApplicant: {
      type: Object,
      default: null
    },
    typeEdo: {
      type: Object,
      default: null
    },
    propertyExtensions: {
      type: Object,
      default: null
    },
  },
  methods: {
    getExtension(propertyCode) {
      return this.propertyExtensions[propertyCode] ?? '*/*';
    },
    addObject() {
      this.form.OBJECTS.push({});
      this.countObjects++
    },
    addBank() {
      this.form.BANK_INFO.push({});
      this.countBanks++
    },
    submitFormThis(event) {
      this.$emit('submitForm', event);
    }
  }
}
</script>